// extracted by mini-css-extract-plugin
export default {"container":"AgentInfo_container__4EbjW","image":"AgentInfo_image__3iitF","rightCol":"AgentInfo_rightCol__5X5df","fullName":"AgentInfo_fullName__EUGu0","bio":"AgentInfo_bio__FBuGp"};